import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { actions as assetTypeDataGridActions } from '../Modules/dataGridTable';
import {
  getAssetTypeListRaw,
  getForceRefresh,
} from '../Selectors/assetTypeSelectors';

const useAssetsType = () => {
  const assetType = useSelector(state => getAssetTypeListRaw(state));
  const forceRef = useSelector(state => getForceRefresh(state));
  const dispatch = useDispatch();

  useEffect(() => {
    if (assetType.length < 1 || forceRef) {
      dispatch(assetTypeDataGridActions.fetchGridList({ filters: {} }));
    }
  }, [assetType.length, dispatch, forceRef]);
  return assetType;
};

export default useAssetsType;
